export default __webpack_public_path__ + "static/media/left-side.50430701.png";